var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addFamily"},[_c('info-form',{attrs:{"isFamily":""},on:{"submit-form":_vm.addFamily}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }